<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class>
          <div class="x_panel">
            <h2 class="float-left">Running Hours Report</h2>
            <ul class="nav navbar-right panel_toolbox align-right">
              <li>
                <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                <button v-if="isPermissionExist(PERMISSIONS.RUNNING_HOUR_JOBS_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                  <i class="fa fa-print" v-if="!isPrinting"></i>
                  <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                  {{ isPrinting ? 'Printing...' : 'Print' }}
                </button>

                <vue-excel-xlsx
                  v-if="isPermissionExist(PERMISSIONS.RUNNING_HOUR_JOBS_REPORT_PRINT)"
                  ref="excel"
                  :data="excelData"
                  :columns="excelHeader"
                  :file-name="'Running Hours Report'"
                  :file-type="'xlsx'"
                  :sheet-name="'sheetname'"
                  :disabled="isPrinting"
                  class="btn btn-primary btn-sm float-right"
                >
                  <div
                    @click.prevent="handleExportPrint('excel')"
                  >
                    <i class="fa fa-file-excel-o"></i>
                    {{ isPrinting ? 'Preparing...' : 'Excel' }}
                  </div>
                </vue-excel-xlsx>
               </li>
            </ul>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body">
                  <div
                    v-if="loading"
                    class="col-md-12 text-center"
                    style="margin-top:25%"
                  >
                    <PulseLoader
                      :loading="loading"
                    ></PulseLoader>
                  </div>
                  <div v-if="!loading">
                    <div class="card-box table-responsive">
                        <div class="x_panel">
                          <div class="x_content">
                            <div class="row justify-content-center">
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Vessel</label>
                                  <select class="form-control" v-model="formData.vessel">
                                    <option value="" selected>Select Vessel</option>
                                    <option v-for="(row, key) in vessels" v-bind:value="{ id: row?.id, name: row?.name }">{{row?.name}}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Date From</label>
                                  <DatePicker type="date" v-model="formData.dateFrom" valueType="format"></DatePicker>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Date To</label>
                                  <DatePicker type="date" v-model="formData.dateTo" valueType="format"></DatePicker>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Critical Jobs</label>
                                  <select class="form-control" v-model="formData.critical_jobs">
                                    <option value>Select Critical Jobs</option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                  </select>
                                </div>
                              </div>

                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Critical Components</label>
                                  <select class="form-control" v-model="formData.critical_component">
                                    <option value>Select Critical Components</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <button style="margin-top: 26px" @click="getRunningHourJobs" class=" btn-info btn btn-sm">Search</button>
                              </div>
                            </div>
                          </div>
                        </div>

                      <div>
                        <div class="mb-3 text-center">
                          <div class="font-weight-bold">Running Hours Report</div>
                          <div v-if="formData.vessel.name != ''">Vessel:
                            <span>{{formData.vessel.name}}  </span>
                          </div>
                          <div v-if="formData.dateFrom != '' && formData.dateTo !=''">
                            Date Period:
                            <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                            <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                          </div>
                        </div>
                        <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                        <TableData
                          :openJobRunningHoursModal="openJobRunningHoursModal"
                          :runningHourJobs="runningHourJobs?.data"
                          :currentPage="Number(runningHourJobs?.current_page)"
                          :perPage="Number(runningHourJobs?.per_page)"
                        >
                        </TableData>
                      </div>
                      <Pagination :pagination="runningHourJobs" :getData="getRunningHourJobs"/>

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <div style="line-height: 10px;" class="font-weight-bold">Running Hours Report</div>
                          <h3 style="line-height: 10px;">Vessel: <span v-if="formData.vessel">{{formData.vessel.name}}</span></h3>
                          <h3 style="line-height: 10px;" v-if="formData.dateFrom != '' && formData.dateTo !=''">
                            Date Period: <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                            <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                          </h3>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>

                        </div>
                        <TableData :runningHourJobs="printItems" :isPrinting="true"></TableData>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Job Running Hours Modal -->
    <div class="modal fade" id="runningHourUpdate" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="runningHourUpdateTitle"> Running Hour Details</h5>

            <div>
              <button @click="print('jobDetailsArea','Running Hour Jobs Details')" class="btn btn-warning btn-sm float-right"><i class="fa fa-print"></i> Print</button>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div>
              <div class="card-box table-responsive">
                <h4 class="text-muted font-13 text-center text-black">Running Hour Report</h4>
                <ModalData :jobRunningHourDetails="jobRunningHourDetails"></ModalData>
                <div id="jobDetailsArea" style="display: none">
                  <div style="text-align: center">
                    <h2 style="line-height: 10px;">{{ appName }}</h2>
                    <h3 style="line-height: 10px;"> Running Hour Details</h3>
                    <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                  </div>
                  <ModalData :jobRunningHourDetails="jobRunningHourDetails" :isPrinting="true"></ModalData>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Job Running Hours Modal -->

  </div>
</template>

<script>

    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import auth from '../../../auth'
    import TableData from "./TableData.vue";
    import ModalData from "./ModalData.vue";
    import {apiPrintData, printUtil} from '@/utils/print'
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        name: 'RunningHourJobReport',
        components: {ModalData, TableData, DatePicker, PulseLoader},
        data() {
            return {
                loading: false,
                value: '',
                runningHourJobs: [],
                printItems: [],
                offset: 20,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                formData: {
                    vessel: {
                        id: '',
                        name: ''
                    },
                    dateFrom: '',
                    dateTo: '',
                    critical_jobs: '',
                    critical_component: '',
                },
                vessels: null,
                jobRunningHourDetails: [],
                vessel_id: auth.getVesselId(),
                permissions: auth.getPermissionData(),
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getVessel();
            this.getRunningHourJobs();
        },
        methods: {

            getVessel() {
                let params = {
                  is_all: 1,
                }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel
                  const selectedVessel = this.vessels.find(vessel => vessel.id == this.vessel_id);
                  if (selectedVessel) {
                    this.formData.vessel = {
                      id: selectedVessel.id,
                      name: selectedVessel.name
                    };
                  }
                }).catch(e => {
                    console.log(e)
                })
            },
            openJobRunningHoursModal(job_id) {
                this.jobRunningHourDetails = [];
                this.$http.get('/api/job-running-hour-details?job_id=' + job_id).then((response) => {
                    this.jobRunningHourDetails = response.data.success;
                    $('#runningHourUpdate').modal('show');
                }).catch((e) => {
                    console.log(e)
                })
            },

          onPerPageChange() {
            this.getRunningHourJobs(1);
          },
          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Job Name(Code)': `${item?.name || ''} (${item?.code || ''})`,
                'Component Name': `${item?.main_components_name || ''} (${item?.main_components_code || ''}) ${item?.components_name || ''} (${item?.components_code || ''})`,
                'Prev Main Date': `${item?.latestJobSchedule?.start_date || ''}`,
                'Est. Due Date': `${item?.est_due_date || ''}`,
                'Prev Main': `${item?.running_hours_value || ''}`,
                'Maintenance Interval': `${item?.running_schedule_value || ''}`,
                'Current Running Hour': `${item?.current_running_hours_value || ''}`,
                'Current Running Hour Value Date': `${item?.current_running_hours_value_date || ''}`,
                'Run Hour Left': `${item?.running_hour_left || ''}`,
                'Daily Running Avg.': `${item?.daily_running_average || ''}`,
                'Est. Days Left': `${item?.est_days_left || ''}`,
              });
            });
            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.formData.vessel_id,
                date_from: this.formData.dateFrom,
                date_to: this.formData.dateTo,
                critical_component: this.formData.critical_component,
                critical_jobs: this.formData.critical_jobs,
                is_all: 1,
              };

              const res = await this.$http.get('/api/running-hour-jobs', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Running Hours Report');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            getRunningHourJobs(page = 1) {
                this.listData = [];
                this.loading = true;
                if (this.formData.vessel) this.formData.vessel_id = this.formData.vessel.id;
                let params = {
                    vessel_id: this.formData.vessel_id,
                    date_from: this.formData.dateFrom,
                    date_to: this.formData.dateTo,
                    critical_component: this.formData.critical_component,
                    critical_jobs: this.formData.critical_jobs,
                    is_all: 0,
                    page: page,
                    offset: this.offset,
                };
                this.$http.get('/api/running-hour-jobs', {params}).then((response) => {
                    this.runningHourJobs = response.data.success;
                    this.loading = false;
                }).catch((e) => {
                    console.log(e);
                    this.loading = false;
                    let response = e.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {

                    }
                })
            },
        },
    }
</script>

<style>
  .mx-datepicker-popup {
    z-index: 9000 !important;
  }

  .des {
    height: 36% !important;
  }
</style>
